import { FC, useState, useEffect } from "react";
import { Chip } from "@mui/material";
import { PriceDetails } from "../../../molecules";
import { HorizontalCard } from "../../../organisms";
import { TransformedProductEntity } from "../../../../types/transformed_product_entity";
import { useLocaleContext } from "../../../context/LocaleContext/LocaleContext";
import { useCart, useWishlist } from "../../../hooks";

export const WishlistItem: FC<{ product: TransformedProductEntity }> = ({
  product,
}) => {
  const [selectedVariant, setSelectedVariant] = useState<string>("");
  const [variantError, setVariantError] = useState<string>("");
  const { currency } = useLocaleContext();
  const activePrice = product.price.find(p => p.code === currency);

  const { deleteFromWishlistHandler, wishlistDataFetching } = useWishlist(
    product.id
  );
  const { addToCartHandler, cartDataFetching } = useCart(product.id);

  const addToCartFromWishlist = async () => {
    if (selectedVariant) {
      await addToCartHandler(selectedVariant);
      await deleteFromWishlistHandler();
    } else {
      setVariantError("Please select a variant");
    }
  };

  useEffect(() => {
    if (product.variants.length === 1) {
      setSelectedVariant(product.variants[0].id);
    }
  }, [product]);

  return (
    <HorizontalCard
      loading={wishlistDataFetching || cartDataFetching}
      title={product.title}
      subtitle={
        <p className="text-xs text-gray-500">
          Product category is{" "}
          <span className="text-gray-900 font-bold">{product.category}</span>
        </p>
      }
      image={product.images[0].url}
      redirectLink={`/products/${product.productHandle}`}
      actionButtons={[
        {
          label: "Add to cart",
          onClick: addToCartFromWishlist,
        },
        {
          id: "wishlist-delete",
          label: "Delete",
          onClick: deleteFromWishlistHandler,
          color: "error",
        },
      ]}>
      <div className="flex flex-col gap-4">
        {activePrice ? <PriceDetails price={activePrice} /> : null}
        <div className="space-y-1">
          <div className="flex gap-2 flex-wrap">
            {product.variants?.map(variant => {
              return (
                <Chip
                  label={variant.size ? variant.size : "One Size"}
                  key={variant.id}
                  size="small"
                  onClick={() => {
                    setSelectedVariant(variant.id);
                    setVariantError("");
                  }}
                  color={
                    selectedVariant === variant.id ? "secondary" : "default"
                  }
                />
              );
            })}
          </div>
          {Boolean(variantError) ? (
            <p className="text-xs text-red-500 font-bold">{variantError}</p>
          ) : null}
        </div>
      </div>
    </HorizontalCard>
  );
};
